module.exports = __webpack_public_path__ + "static/media/Hair_2.363439c4.jpg";